import "./hide-on-cookie"

class MobileHeader {
    toggleXxlElement: HTMLElement | null = null
    toggleXxlHeader: HTMLElement | null = null
    baseSelector = ".mobile-header-banner.mobile-header-banner-city-highlight"

    constructor() {
        const SeasonalBannerContainer = document.querySelector(this.baseSelector)

        if (!SeasonalBannerContainer) {
            console.warn("Did not find SeasonalBannerContainer for CityHighlight with selector: ", this.baseSelector)
            return
        }

        this.toggleXxlElement = SeasonalBannerContainer.querySelector(".touch-xxl-spot")
        this.toggleXxlHeader = SeasonalBannerContainer.querySelector(".xxl-header")

        this.initializeHeaderEvents()
        this.initializeBLazy()
    }

    initializeHeaderEvents() {
        this.toggleXxlElement?.addEventListener("click", (clickEvent) => this.toggleXxlBannerContainer(clickEvent))

        this.toggleXxlHeader?.addEventListener("click", (clickEvent) => this.toggleXxlBannerContainer(clickEvent, true))
    }

    initializeBLazy() {
        /*new Blazy({
			container: '#seasonal-thumb-container',
			offset: 500
		});*/
    }

    toggleXxlBannerContainer(/**Event*/ clickEvent: MouseEvent, /**boolean?*/ onlyToggleOpen = false) {
        const /**HTMLElement*/ clickElement = clickEvent.target
        // @ts-expect-error its fine. TODO improve/fix
        const /**HTMLElement*/ containerElement = clickElement?.closest(this.baseSelector)

        if (containerElement.classList.contains("closed")) {
            containerElement.classList.remove("closed")
            document.dispatchEvent(new Event("xxlbanner:onopen"))

            this.trackBannerImpression(containerElement)
        } else if (!onlyToggleOpen) {
            containerElement.classList.add("closed")
            document.dispatchEvent(new Event("xxlbanner:onclose"))
        }
    }

    trackBannerImpression(container: HTMLElement) {
        const trackingBase = container.closest(".tparent[data-directly]") as HTMLElement

        // @ts-expect-error idk how this works. TODO fix/improve
        if (trackingBase === null || !trackingBase.length) {
            return void this.generateTrackingPixels(container.querySelectorAll(".tpixel[data-source]"))
        }

        this.loadTrackingPixel(trackingBase)
    }

    loadTrackingPixel(/**HTMLElement*/ tParent: HTMLElement) {
        const bannerId = Number.parseInt(tParent.dataset.bannerId || "", 10)
        const bannerPlace = Number.parseInt(tParent.dataset.bannerPlace || "", 10)

        if (!bannerId || !bannerPlace) {
            return
        }

        window.Tracking.trackBannerEinblendung(bannerId, bannerPlace)
    }

    generateTrackingPixels(tPixels: NodeListOf<HTMLElement>) {
        if (!tPixels.length) {
            return
        }

        for (const tPixel of tPixels) {
            tPixel.setAttribute("src", tPixel.dataset.source || "")
            tPixel.style.display = "block"
        }
    }
}

new MobileHeader()
